import * as Yup from "yup";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { RequirementExpirationStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import { RequirementDefinitionTemplate } from "../../routes/RouteCreateRequirementByTemplate/types";

const allowedTypes = Object.values(RequirementType);
const defaultExpirationStrategies = Object.values(
  RequirementExpirationStrategy
);

const allAllowedExpirationStrategiesValues = [
  ...defaultExpirationStrategies,
  "None"
];

export const requirementDefinitionDefaultValidationSchema = (
  template: RequirementDefinitionTemplate
) =>
  Yup.object().shape({
    name: Yup.string().required("Name is required"),
    type: Yup.string().oneOf(allowedTypes).required("Type is required"),
    instructions: Yup.mixed().when("type", {
      is(type: RequirementType) {
        return [
          RequirementType.BackgroundCheck,
          RequirementType.SharedFile,
          RequirementType.IdentityVerification
        ].includes(type);
      },
      then: Yup.string(),
      otherwise: Yup.mixed().notRequired()
    }),
    description: Yup.string(),
    manualRenewalAllowed: Yup.boolean().notRequired(),
    expirationStrategy: template.noExpirationForm
      ? Yup.mixed().notRequired()
      : Yup.string().oneOf(allAllowedExpirationStrategiesValues),
    expirationDays: template.noExpirationForm
      ? Yup.mixed().notRequired()
      : Yup.number().when("expirationStrategy", {
          is(type: RequirementExpirationStrategy) {
            return [
              RequirementExpirationStrategy.DaysBeforeYearEnd,
              RequirementExpirationStrategy.DaysAfterComplete,
              RequirementExpirationStrategy.DaysAfterYearStart
            ].includes(type);
          },
          then: Yup.number()
            .min(1)
            .max(10 * 365)
            .required("Expiration days is required"),
          otherwise: Yup.number().notRequired()
        })
  });
